module.exports = __webpack_public_path__ + "img/jfcg@2x.c29da7be.png";